import * as Toast from '@radix-ui/react-toast';
import parse from 'html-react-parser';
import { isString } from 'lodash';
import { useMemo, useSyncExternalStore } from 'react';
import store from './';

export default function NotifyContainer() {
  const list = useSyncExternalStore(store.subscribe, store.getSnapshot);

  const items = useMemo(() => {
    return Object.keys(list).map((id) => {
      const m = list[id];
      if (!m) {
        return null;
      }
      const duration = m.duration || 2_000;
      let borderColor = '';
      if (m.type === 'error') {
        borderColor = 'border-red-500';
      } else if (m.type === 'warning') {
        borderColor = 'border-yellow-500';
      }

      let theMessage = m.message;
      if (isString(m.message) && m.message.includes('<div>')) {
        theMessage = parse(m.message);
      }

      return (
        <Toast.Root
          duration={duration}
          key={id}
          className={`rounded-md border ${borderColor} bg-white p-4 text-left shadow data-[swipe=cancel]:translate-x-0 data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[state=closed]:animate-hide data-[state=open]:animate-slide-in data-[swipe=end]:animate-swipe-out data-[swipe=cancel]:transition-[transform_200ms_ease-out]`}
          onOpenChange={(isOpen) => {
            if (!isOpen) {
              store.delete(id);
            }
          }}
        >
          {m.title && <Toast.Title className="text-sm font-noto font-semibold">{m.title}</Toast.Title>}
          <Toast.Description className="text-sm font-noto">{theMessage}</Toast.Description>
        </Toast.Root>
      );
    });
  }, [list]);

  return <>{items}</>;
}
